let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("4waaI"), load("h7oxu"), load("6MNAi"), load("425pi"), load("6aruy")]).then(() => parcelRequire('9VKkC'));